// extracted by mini-css-extract-plugin
export var chip = "_5y-9";
export var chipLabel = "_5y-a";
export var close = "_5y-7";
export var closeIcon = "_5y-8";
export var error = "_5y-6";
export var infoTooltip = "_5y-2";
export var innerContainer = "_5y-1";
export var input = "_5y-b";
export var medium = "_5y-5";
export var outerContainer = "_5y-0";
export var small = "_5y-4";
export var xSmall = "_5y-3";